'use client';
import { useEffect, type ReactNode } from 'react';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import dayjs from 'dayjs';

import { useAppDispatch, useAppSelector } from '@/redux-store/hooks';
import { fetchTranslations } from '@/redux-store/slices/translation';
import LogoLoading from './LogoLoading';

export default function ClientLocalizationProvider({
    children,
}: {
    children: ReactNode;
}) {
    const dispatch = useAppDispatch();

    const lang = useAppSelector(state => state.translation.lang);
    const loading = useAppSelector(state => state.translation.loading);

    useEffect(() => {
        dayjs.locale(lang);
        dispatch(fetchTranslations(lang));
    }, [dispatch, lang]);

    if (loading) return <LogoLoading />;

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            {children}
        </LocalizationProvider>
    );
}
